/**
 * Home Intro Animation
 * @dependencies gsap
 * @dependencies imagesLoaded
 * @dependencies splitting.js
 */

import { TimelineLite, Power4, Power3, Power2 } from 'gsap'
import Splitting from "splitting"

if (document.body.classList.contains('home')) {

  // DOM Els
  const cover = document.querySelector('.js-cover')
  const title = document.querySelector('.js-title')
  const sign = document.querySelector('.js-sign')
  const mouse = document.querySelector('.js-mouse')

  // Splitting
  const titleSplit = Splitting({ target: title, by: 'lines' })
  const titleWords = titleSplit[0].words

  const tl = new TimelineLite()
  tl
    .to(cover, 2, { alpha: 1, ease: Power2.easeOut })
    .to(cover, 4, { scale: 1, ease: Power4.easeOut }, 0)
    .set(title, { autoAlpha: 1 }, 0.6)
    .staggerFromTo(titleWords, 1.2, { y: 50, autoAlpha: 0 },{ y: 0, autoAlpha: 1, ease: Power3.easeOut }, 0.045, 0.6)
    .fromTo(sign, 1, { y: 30, autoAlpha: 0 },{ y: 0, autoAlpha: 1, ease: Power3.easeOut }, 1.2)
    .fromTo(mouse, 1, { y: 30, autoAlpha: 0 },{ y: 0, autoAlpha: 1, ease: Power3.easeOut }, 1.4)
}
